import { deepClone } from '@/utils/api';

export function buildMenuIndex(pageMenuVOS = []) {
	const moduleIdMap = new Map();
	const uuidMap = new Map();
	const menuTree = pageMenuVOS.map(menu => normalizeMenu(menu, moduleIdMap, uuidMap)).sort((a, b) => a.sort - b.sort);

	return {
		menuTree,
		moduleIdMap,
		uuidMap
	};
}

/**
 * 构建 moduleId 到可路由顶层菜单的映射。
 * 仅映射顶层菜单自身的 moduleVOS：目标路由的 MenuFrame 只渲染顶层菜单模块，
 * 子菜单模块不参与映射，避免生成无法渲染的空白页面。
 */
export function buildModuleMenuMap(pageMenuVOS = []) {
	const moduleMenuMap = new Map();
	const sortedMenus = [...pageMenuVOS].sort((a, b) => (a?.sort || 0) - (b?.sort || 0));

	sortedMenus.forEach(menu => {
		if (!menu || menu.isDefault) return;

		const menuId = menu.uuid || menu.id;
		if (!menuId) return;

		(menu.moduleVOS || []).forEach(module => {
			if (module?.moduleId === undefined || module?.moduleId === null || module?.moduleId === '') return;

			const moduleId = String(module.moduleId);
			if (!moduleMenuMap.has(moduleId)) {
				moduleMenuMap.set(moduleId, menuId);
			}
		});
	});

	return moduleMenuMap;
}

function normalizeMenu(menu, moduleIndexMap, uuidMap) {
	const { uuid, name, sort = 0, pageMenuVOS = [], moduleVOS = [] } = menu;

	const node = {
		uuid,
		name,
		sort,

		meta: deepClone(menu),
		children: [],
		modules: []
	};

	// 将当前节点添加到 uuidMap
	if (uuid) {
		uuidMap.set(uuid, node);
	}

	// 子菜单
	if (Array.isArray(pageMenuVOS)) {
		node.children = pageMenuVOS
			.map(child => normalizeMenu(child, moduleIndexMap, uuidMap))
			.sort((a, b) => a.sort - b.sort);
	}

	// 模块
	if (Array.isArray(moduleVOS)) {
		node.modules = moduleVOS.map(m => normalizeModule(m, uuid, moduleIndexMap)).sort((a, b) => a.sort - b.sort);
	}

	return node;
}

function normalizeModule(module, menuUuid, moduleIndexMap) {
	const { moduleId, sort = 0 } = module;

	// 构建 moduleId -> menuUuid Set
	if (!moduleIndexMap.has(moduleId)) {
		moduleIndexMap.set(moduleId, new Set());
	}
	moduleIndexMap.get(moduleId).add(menuUuid);

	return {
		moduleId,
		sort,
		raw: deepClone(module)
	};
}
